// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warp[data-v-18b6b2ec] .el-descriptions-item__label {\n  font-size: 13px;\n  color: #909399;\n}\n.warp[data-v-18b6b2ec] .el-descriptions-item__cell {\n  /*height: 35px !important;*/\n  padding-bottom: 2px !important;\n}\n.QuestionMark[data-v-18b6b2ec] {\n  cursor: pointer;\n  color: #00A551;\n}\n.el-descriptions-item__cell div[data-v-18b6b2ec] {\n  font-weight: bold;\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
